module.exports = __webpack_public_path__ + "img/cause1Blue.ff9f6c83.png";